import {useCallback, useState} from 'react'

type Options<T> = {
	parse?: (value: string | null) => T
	serialize?: (value: T) => string
}

export function useQueryState<T = string>(
	key: string,
	initialValue: T,
	options?: Options<T>
) {
	const parse = options?.parse ?? ((v) => v as unknown as T)
	const serialize = options?.serialize ?? ((v) => String(v))
	
	const getFromUrl = (): T => {
		const params = new URLSearchParams(window.location.search)
		const value = params.get(key)
		return value !== null ? parse(value) : initialValue
	}
	
	const [state, _setState] = useState<T>(getFromUrl)
	
	const setState = useCallback((value: T) => {
		const params = new URLSearchParams(window.location.search)
		
		if (value === null || value === undefined || value === '') {
			params.delete(key)
		} else {
			params.set(key, serialize(value))
		}
		
		const newUrl = window.location.pathname + (params.toString() ? `?${params.toString()}` : '')
		
		window.history.replaceState(null, '', newUrl)
		_setState(value)
	}, [_setState])
	
	return [state, setState] as const
}